const jQ = jQuery.noConflict();
const nextBtn = jQ('.custom-next-btn');
const prevBtn = jQ('.custom-prev-btn');
const sliderItem = jQ('.ff-slider-item');

function animateItems(el, next) {
    const item = el.find('.mask');

    if (next) {
        if (item.hasClass('move-after') && item.hasClass('move-after-more')) {
            item.addClass('move-before');
        } else {
            item.addClass('move-after');
        }
    } else if (item.hasClass('move-before')) {
        item.removeClass('move-before');
    } else if (item.hasClass('move-after-more') && !(item.hasClass('more-before'))) {
        item.removeClass('move-after-more');
    } else {
        item.removeClass('move-after');
    }
}

function sliderFirst() {
    sliderItem.first().addClass('active-slider-item');
    sliderItem.first().find('.mask').removeClass('move-after');
}

function prevSlide() {
    nextBtn.removeClass('disabled-btn');
    const sliderActive = jQ('.ff-slider-item.active-slider-item');
    const prevItem = sliderActive.prev();
    if (prevItem.length > 0) {
        animateItems(sliderActive, false);
        setTimeout(() => {
            sliderActive.removeClass('active-slider-item');
            prevItem.addClass('active-slider-item');
            const newActive = prevItem;
            const mask = newActive.find('.mask');

            if (mask.hasClass('move-before')) {
                mask.delay(200).queue(() => {
                    mask.removeClass('move-before').dequeue();
                });
            } else if (mask.hasClass('move-after-more') && !(mask.hasClass('move-before'))) {
                mask.delay(200).queue(() => {
                    mask.removeClass('move-after-more');
                });
            } else {
                mask.delay(200).queue(() => {
                    mask.removeClass('move-after').dequeue();
                });
            }

            if (newActive.prev().length > 0) {
                prevBtn.removeClass('disabled-btn');
            } else {
                prevBtn.addClass('disabled-btn');
            }
        }, 300);
    } else {
        prevBtn.addClass('disabled-btn');
    }
}

function nextSlide() {
    prevBtn.removeClass('disabled-btn');
    const sliderActive = jQ('.ff-slider-item.active-slider-item');
    const nextItem = sliderActive.next();
    if (nextItem.length > 0) {
        animateItems(sliderActive, true);
        setTimeout(() => {
            sliderActive.removeClass('active-slider-item');
            nextItem.addClass('active-slider-item');
            const newActive = nextItem;
            const mask = newActive.find('.mask');

            if (mask.hasClass('move-after') && mask.hasClass('move-after-more')) {
                mask.delay(200).queue(() => {
                    mask.addClass('move-before').dequeue();
                });
            } else if (mask.hasClass('move-after') && !(mask.hasClass('move-after-more'))) {
                mask.delay(50).queue(() => {
                    mask.addClass('move-after-more').dequeue();
                });
            } else {
                mask.delay(200).queue(() => {
                    mask.addClass('move-after').dequeue();
                });
            }
            if (newActive.next().length > 0) {
                nextBtn.removeClass('disabled-btn');
            } else {
                nextBtn.addClass('disabled-btn');
            }
        }, 300);
    } else {
        nextBtn.addClass('disabled-btn');
    }
}

function setHeight() {
    if (jQ('.block-fast-facts').length > 0) {
        jQ('.block-fast-facts').each(function () {
            const items = jQ(this).find('.ff-slider-item');
            const firstItem = jQ(this).find('.ff-slider-item').first();
            const height = firstItem.outerHeight();
            items.css('min-height', height);
        });
    }
}

function changeSlider() {
    nextBtn.on('click', nextSlide);
    prevBtn.on('click', prevSlide);
}

function initSlider() {
    sliderFirst();
    changeSlider();
    setHeight();
}

export default initSlider;
